import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  standalone: false,
  name: 'niStatus',
})
export class NiStatusPipe implements PipeTransform {
  transform(value: boolean): string {
    return value ? 'Completed' : 'Incomplete';
  }
}
